const apiUrl = process.env.REACT_APP_API_URL
const kpiUrl = process.env.REACT_APP_KPI_URL
const productName = process.env.REACT_APP_PRODUCT_NAME
const photoUrlWatermark = process.env.REACT_APP_PHOTO_URL_WATERMARK
const photoUrlMedium = process.env.REACT_APP_PHOTO_URL_MEDIUM
const photoUrlSmall = process.env.REACT_APP_PHOTO_URL_SMALL
const beforeAfter = process.env.REACT_APP_BEFORE_AFTER
const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY
const thumbnailsPath = '/images/thumbnails/'
const defaultThumbnailsCount = 12

const config = {
  mapCenter: { lat: 42.95077, lng: 0.57262603 },
  mapPoiZoom: 12,
  mapPoisZoom: 11,
  mapHeight: '400px',
  photoUrlMedium: photoUrlMedium,
  photoUrlSmall: photoUrlSmall,
  photoUrlWatermark: photoUrlWatermark,
  beforeAfter: beforeAfter,
  apiUrl: apiUrl,
  kpiUrl: kpiUrl,
  productName: productName,
  recaptchaKey: recaptchaKey,
  thumbnailsPath: thumbnailsPath,
  defaultThumbnailsCount: defaultThumbnailsCount,
  poiTypesWithThumbnail: [
    'VILLAGE',
    //'ACCOMODATION',
    'CURIOSITY',
    'WILDLIFE',
    'WALK',
    'HIKING',
    'TRAIL',
    'MOUNTAIN_BIKING',
    'ROAD_CYCLING',
    'PICNIC',
    'WATER_POINT',
    'HISTORY',
    'CLIMBING',
    'RAMPAGE',
  ],
  poiTypesWithAltitude: [
    'VILLAGE',
    'WALK',
    'CURIOSITY',
    'PICNIC',
    'CLIMBING',
    'PARAGLIDING',
    'FISHING',
    'ACCOMODATION',
  ],
  poiTypesWithPhoneAndEmail: [
    'SERVICE',
    'SHOP',
    'CULTURE_EVENT',
    'SHOP_EVENT',
    'SPORT_EVENT',
    'TRAIL_EVENT',
    'SERVICE_EVENT',
  ],

  homepagePoiTypes: [
    'VILLAGE',
    'HISTORY',
    'CURIOSITY',
    //'ACCOMODATION',
    'WALK',
    'HIKING',
    'TRAIL',
    'MOUNTAIN_BIKING',
    'ROAD_CYCLING',
    'PICNIC',
    'WATER_POINT',
    'WILDLIFE',
    'CLIMBING',
    'RAMPAGE',
  ],
  bottomImages: {
    TERMS_OF_USE: {
      photoId: '95cc8f97-0f60-4275-a019-d2f30f928654',
      labelFr: 'Le ruisseau de Salabe',
      labelEn: 'The Salabe stream',
      labelEs: 'El arroyo de Salabe',
    },
    CONTACT: {
      photoId: 'f907b8e3-2713-4b3d-b45f-6b802e77c126',
      labelFr: 'L’allium capte, filtre, recueille. À vous.',
      labelEn: 'The allium captures, filters, collects. Your turn.',
      labelEs: 'El allium capta, filtra, recoge. Adelante.',
    },
    EVENTS: {
      photoId: 'f907b8e3-2713-4b3d-b77f-6b802e77c149',
      labelFr: 'Le brandon du Port de Balès',
      labelEn: 'The brandon of Port de Balès',
      labelEs: 'El Brandon del Port de Balès',
    },
    FAQ: {
      photoId: '95cc8f97-0f60-4275-a019-d2f30f928658',
      labelFr: 'La carrière de marbre de Sost.',
      labelEn: 'The marble quarry of Sost.',
      labelEs: 'La cantera de mármol de Sost.',
    },
    REVES_DE_BAROUSSE: {
      photoId: '95cc8f97-0f60-4275-a019-d2f30f928651',
      labelFr: 'Les chèvres férales du Tourroc',
      labelEn: 'The feral goats of Tourroc',
      labelEs: 'Las cabras ferales de Tourroc',
    },
    LEGAL_NOTICES: {
      photoId: '95cc8f97-0f60-4275-a019-d2f30f928659',
      labelFr: 'Sur la route du Mont Las depuis le Cap de la Lane',
      labelEn: 'On the road to Mont Las from Cap de la Lane',
      labelEs: 'En la ruta al Mont Las desde el Cap de la Lane',
    },
    OUR_TEAM: {
      photoId: '',
      labelFr: '',
      labelEn: '',
      labelEs: '',
    },
    PAGE_NOT_FOUND: {
      photoId: 'f907b8e3-2713-4b3d-b45f-6b802e77c154',
      labelFr: 'Illustration : chemin perdu',
      labelEn: 'Illustration: lost path',
      labelEs: 'Ilustración: camino perdido',
    },
    POI_TYPE_ACCOMODATION: {
      photoId: 'f907b8e3-2713-4b3d-b45f-6b802e77c123 (35)',
      labelFr: 'Inexorablement la nature fermera toutes les fenêtres.',
      labelEn: 'Inexorably, nature will close all the windows.',
      labelEs: 'Inexorablemente, la naturaleza cerrará todas las ventanas.',
    },
    POI_TYPE_HIKING: {
      photoId: 'f907b8e3-2713-4b3d-b45f-6b802e77c144',
      labelFr:
        "Autrefois vert, le clocher de Sacoué partira avec les secrets d'un autre siècle.",
      labelEn:
        'Once green, Sacoué’s bell tower will carry away the secrets of another century.',
      labelEs:
        'Antes verde, el campanario de Sacoué se llevará los secretos de otro siglo.',
    },
    POI_TYPE_MOUNTAIN_BIKING: {
      photoId: '95cc8f97-0f60-4275-a019-d2f30f928657',
      labelFr: '', //Vue d’un parcours VTT dans la fraîcheur des bois de Barousse.',
      labelEn: '', //View of a mountain biking trail in the cool Barousse woods.',
      labelEs: '', //Vista de un recorrido de bicicleta de montaña en los bosques frescos de Barousse.',
    },
    POI_TYPE_ROAD_CYCLING: {
      photoId: 'f907b8e3-2713-4b3d-b45f-6b802e77c151',
      labelFr:
        'Dans la descente du col de Mortis le monde se simplifie : une route, une vallée.',
      labelEn: 'Down the Mortis pass, the world simplifies: a road, a valley.',
      labelEs:
        'En la bajada del collado de Mortis, el mundo se simplifica: una carretera, un valle.',
    },
    POI_TYPE_VILLAGE: {
      photoId: '95cc8f97-0f60-4275-a019-d2f30f998657',
      labelFr: "En haute Barousse, le village d'Ourde vu depuis son balcon.",
      labelEn: 'In Upper Barousse, the village of Ourde seen from its balcony.',
      labelEs: 'En la alta Barousse, el pueblo de Ourde visto desde su balcón.',
    },
    POI_TYPE_WALK: {
      photoId: 'f907b8e3-2713-4b3d-b45f-6b802e77c138',
      labelFr: 'Le lac de Loures-Barousse',
      labelEn: 'Lake of Loures-Barousse',
      labelEs: 'El lago de Loures-Barousse',
    },
    POI_TYPE_RAMPAGE: {
      photoId: 'f907b8e3-2713-4b3d-b45f-99802e77c199',
      labelFr: 'La colonie de vacances abandonnée (Ourde)',
      labelEn: 'The abandoned summer camp (Ourde)',
      labelEs: 'El campamento de verano abandonado (Ourde)',
    },
    POI_TYPE_WATER_POINT: {
      photoId: 'd907b8e3-2713-4b3d-b45f-6b802e77c153',
      labelFr:
        'Que d’eau ! Que d’eau ! Le président vit le dessus — les dessous coulaient déjà ici.',
      labelEn:
        'So much water! So much water! The president saw only the surface — the depths were already flowing.',
      labelEs:
        '¡Cuánta agua! ¡Cuánta agua! El presidente solo vio la superficie — lo profundo ya fluía.',
    },
    POI_TYPE_WILDLIFE: {
      photoId: 'd907b8e3-2713-4b3d-b45f-6b802e77z153',
      labelFr:
        'De retour dans les Pyrénées il observe ce berger en 4x4 guider des moutons, survolé par une bondrée apivore.',
      labelEn:
        'Back in the Pyrenees, he watches a shepherd in a 4x4 guiding sheep, while a honey buzzard flies overhead.',
      labelEs:
        'De vuelta en los Pirineos, observa a un pastor en un todoterreno guiando ovejas, mientras un abejero europeo sobrevuela la escena.',
    },
    POI_TYPE_HISTORY: {
      photoId: 'd907b8e3-2713-4b3d-b45f-6e802e77z153',
      labelFr: 'Des hommes organisés face à la vallée',
      labelEn: 'Organized men facing the valley',
      labelEs: 'Hombres organizados frente al valle',
    },
    POI_TYPE_CLIMBING: {
      photoId: 'z907b8e3-2713-4b3d-b45f-6e802e77z153',
      labelFr: 'Des voies équipées, dans toute la vallée',
      labelEn: 'Equipped climbing routes throughout the valley',
      labelEs: 'Vías equipadas en todo el valle',
    },
    REGISTER_CONFIRMATION: {
      photoId: 'f907b8e3-2713-4b3d-b450-6b802e77c123',
      labelFr: 'Vue du Tourroc, paisible témoin d’un nouveau départ.',
      labelEn: 'View from Tourroc, peaceful witness to a new beginning.',
      labelEs: 'Vista desde Tourroc, testigo tranquilo de un nuevo comienzo.',
    },
    SUPPORT: {
      photoId: 'f907b8e3-2713-4b3d-b45f-6b802e77c149',
      labelFr: "La bonne herbe pour l'agneau de Sacoué",
      labelEn: 'Good grass for the lamb of Sacoué',
      labelEs: 'La buena hierba para el cordero de Sacoué',
    },
  },
}

export default config
